module.exports = __webpack_public_path__ + "img/ep-2-dosis.dc62c0e2.jpg";